module.exports = __webpack_public_path__ + "static/media/location-verde_old.90777d34.svg";